var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('w-camera-button',{attrs:{"disabled":_vm.disabled},on:{"click":_vm.handleCameraEvent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }